import { createEpisode } from './create-episode.service';
import { deleteEpisode } from './delete-episode.service';
import { getEpisodeDetails } from './get-episode-details.service';
import { getEpisodes } from './get-episodes.service';
import { getHosts } from './get-hosts.service';
import { updateEpisode } from './update-episode.service';
import { updateHostById } from './update-host-by-id.service';
import { updateHostsQuantity } from './update-hosts-quantity.service';

export const episodesService = {
  getHosts,
  getEpisodes,
  deleteEpisode,
  updateEpisode,
  createEpisode,
  getEpisodeDetails,
  updateHostsQuantity,
  updateHostById,
};
